function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoDashboardActifFond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.583333 10.583334",
    height: 36,
    width: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none"
    },
    y: 0,
    x: 0,
    id: "Rectangle_943",
    "data-name": "Rectangle 943",
    width: 25.23,
    height: 21.906
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-100.94373,-142.88417)",
    style: {
      display: "inline"
    },
    id: "layer2"
  }, /*#__PURE__*/React.createElement("rect", {
    ry: 2.7,
    rx: 2.7,
    y: 142.88417,
    x: 100.94373,
    height: 10.583333,
    width: 10.583333,
    id: "rect104",
    style: {
      opacity: 1,
      fill: "#0a3b50",
      fillOpacity: 1,
      strokeWidth: 0.35277689
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-100.94373,-142.88417)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3434",
    "data-name": "Groupe 3434",
    transform: "matrix(0.26458333,0,0,0.26458333,102.9106,145.27786)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3434-2",
    "data-name": "Groupe 3434",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    id: "Trac\\xE9_1199",
    "data-name": "Trac\\xE9 1199",
    d: "m 15.49,11.578 -4.6,3.208 a 4.976,4.976 0 0 1 -6.935,-1.2 L 3.944,13.571 A 5.008,5.008 0 0 1 5.213,6.616 l 2.4,-1.674 C 7.666,4.905 10.084,3.228 10.131,3.187 A 2.675,2.675 0 0 0 6.1,2.21 L 3.432,4.052 a 8.1,8.1 0 0 0 9.241,13.3 L 17,14.3 c 0.046,-0.033 2.461,-1.7 2.5,-1.739 a 2.673,2.673 0 0 0 -4.012,-0.982",
    transform: "translate(0,-0.728)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    id: "Trac\\xE9_1200",
    "data-name": "Trac\\xE9 1200",
    d: "m 7.955,0.009 4.3,6.184 L 14.6,0 Z",
    transform: "translate(-3.553)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4cbb17"
    },
    id: "Trac\\xE9_1201",
    "data-name": "Trac\\xE9 1201",
    d: "m 14.365,14.167 4.6,-3.208 a 4.976,4.976 0 0 1 6.935,1.2 l 0.011,0.015 a 5.008,5.008 0 0 1 -1.268,6.955 l -2.4,1.674 c -0.052,0.037 -2.471,1.714 -2.517,1.755 a 2.674,2.674 0 0 0 4.029,0.978 L 26.42,21.693 A 8.1,8.1 0 0 0 17.182,8.4 l -4.327,3.051 c -0.046,0.033 -2.461,1.7 -2.5,1.739 a 2.673,2.673 0 0 0 4.012,0.982",
    transform: "translate(-4.624,-3.111)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4cbb17"
    },
    id: "Trac\\xE9_1202",
    "data-name": "Trac\\xE9 1202",
    d: "m 32.277,34.583 -4.3,-6.184 -2.343,6.193 z",
    transform: "translate(-11.448,-12.685)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoDashboardActifFond);
export default __webpack_public_path__ + "static/media/picto-dashboard-actif-fond.7fc9b01fe6e241b35d11dd77ed89cbfb.svg";
export { ForwardRef as ReactComponent };